import React from "react";
import { Reveal, MaskLines } from "@/components/Motion";
import { aboutDhamma as a, brand, images } from "@/config/site";

export default function AboutDhamma() {
  return (
    <>
      <section data-testid="about-dhamma-hero" className="relative overflow-hidden pt-40 pb-24 sm:pt-52 sm:pb-32">
        <div className="absolute inset-0 -z-10">
          <img src={images.pagesMotif} alt="Book pages curling into shadow" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-dh-bg via-dh-bg/90 to-dh-bg" />
        </div>
        <div className="mx-auto max-w-[1000px] px-5 sm:px-8">
          <Reveal>
            <p className="font-body text-[11px] uppercase tracking-ultra text-dh-gold">About Dhamma</p>
          </Reveal>
          <h1 className="mt-6 font-display text-4xl leading-[1.06] text-dh-cream sm:text-6xl lg:text-7xl">
            <MaskLines lines={["Stories Like Ours", "Deserve to Be Told."]} />
          </h1>
        </div>
      </section>

      <section className="bg-dh-bg pb-28 sm:pb-36">
        <div className="mx-auto max-w-[820px] px-5 sm:px-8">
          <Reveal>
            <p className="font-serif-soft text-2xl italic leading-snug text-dh-cream sm:text-3xl">{a.opening}</p>
          </Reveal>
          <div className="mt-10 space-y-6">
            {a.body.map((p, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <p className="font-body text-base leading-relaxed text-dh-cream/75 sm:text-lg">{p}</p>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="my-16 grid gap-6 sm:grid-cols-2">
              {a.statements.map((s, i) => (
                <div key={i} className="border border-dh-gold/25 bg-dh-forest/20 p-8">
                  <p className="font-display text-2xl leading-tight text-dh-cream sm:text-3xl">{s}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal>
            <p className="border-l border-dh-gold/40 pl-6 font-body text-base leading-relaxed text-dh-cream/80 sm:pl-8 sm:text-lg">
              {a.acquiredTaste}
            </p>
          </Reveal>

          <Reveal>
            <div className="mt-20 text-center">
              <div className="gold-rule mx-auto mb-8 w-24" />
              <p className="font-display text-3xl italic text-dh-gold sm:text-4xl">{brand.tagline}</p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
